<!--[style.margin-left]="sideMargin"
    [style.margin-top]="topMargin"
    [ngClass]="{'visibility-non': topMargin == 0}"-->
<div id="main-text-info-popup"
     class="main-wrapper">

    <div [ngClass]="isBusinessDoctors ? 'main-title-wrapper-business-doctors' : 'main-title-wrapper'">
<!--        <div class="info-logo"></div>-->
        <div [ngClass]="isBusinessDoctors ? 'main-title-text-business-doctors' : 'main-title-text'" class="h3Font"> {{titleText}} </div>
        <div (click)="close()" class="exit-logo"></div>
    </div>

    <div [ngClass]="isBusinessDoctors ? 'main-info-text-business-doctors' : 'main-info-text'" class=" p1Font b1Color" [innerHTML]="bodyText | safeHtml"></div>

    <div *ngIf="pointer === 'right'" class="arrow-wrapper-right">
        <svg class="arrow" [height]="20" [width]="10" [ngStyle]="{'top': arrowTop}">
            <polygon *ngIf="!isBusinessDoctors" points="0,0 10,10 0,20" fill="#CBEEF9"></polygon>
            <polygon *ngIf="isBusinessDoctors" points="0,0 10,10 0,20" fill="#E6F3FC"></polygon>
        </svg>
    </div>
    <div *ngIf="pointer === 'left'" class="arrow-wrapper-left">
        <svg class="arrow" [height]="20" [width]="10" [ngStyle]="{'top': arrowTop}">
            <polygon *ngIf="!isBusinessDoctors" points="10,0 0,10 10,20" fill="#CBEEF9"></polygon>
            <polygon *ngIf="isBusinessDoctors" points="10,0 0,10 10,20" fill="#E6F3FC"></polygon>
        </svg>
    </div>

</div>
